module.exports = __webpack_public_path__ + "img/img(1).f7c996bc.png";